<template>
  <main-layout>
    <router-view :key="$route.fullPath" />
  </main-layout>
</template>
<script>
/**
 * ==================================================================================
 * Job layout
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'

export default {
  components: {
    MainLayout
  }
}
</script>
